import { custServiceApi, stafPlanApi } from '@/helpers/apis';
import axios from '@/helpers/axios';

export const getServiceNumbers = (page, size, brn, email, searchSvcNo) => {
  const url = `${custServiceApi.GET_SERVICE_NUMBERS_BY_BRN}?page=${page}&size=${size}`;
  const payload = { brn: brn, email: email, searchSvcNo: searchSvcNo };
  return axios.post(url, payload);
};

export const getServiceEligibilityDetails = (brn, email, serviceNoList) => {
  const url = custServiceApi.GET_SERVICE_NUMBER_ELIGIBILITY_DETAILS;
  const payload = { brn: brn, email: email, serviceNos: serviceNoList };
  return axios.post(url, payload);
};

export const getStaffPlanEligibility = (employeeId) => {
  const url = `${stafPlanApi.GET_STAFF_PLAN_ELIGIBILITY}${employeeId}`;
  return axios.get(url);
};

export const staffPlanReconEligibility = (serviceNoList) => {
  const url = `${stafPlanApi.STAFF_PLAN_RECON_ELIGIBILITY}`;
  const payload = { serviceNumber: serviceNoList };
  return axios.post(url, payload);
};
